import React from 'react';
import classNames from 'classnames';

import ToolbarPopup from '../../../toolbarPopup/ToolbarPopup';
import LabelsToolbarPopupContent from './LabelsToolbarPopupContent';
import { TooltipAlignment } from '../../../../../../components/tooltips/tooltipConstants';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import { LabelsToolbarPopupProps } from '../labelComponentPropTypes';

import './LabelsToolbarPopup.scss';

const LabelsToolbarPopup: React.FC<
    LabelsToolbarPopupProps & {
        buttonSelector: string;
    }
> = (props) => {
    const { buttonSelector } = props;

    return (
        <ToolbarPopup
            buttonSelector={buttonSelector}
            alignment={TooltipAlignment.START}
            popupId={PopupIds.LABELS_TOOL}
            className={classNames('LabelsPopup')}
            showArrow={false}
        >
            <LabelsToolbarPopupContent {...props} />
        </ToolbarPopup>
    );
};

export default LabelsToolbarPopup;
